module.exports = __webpack_public_path__ + "static/media/icon-7.3e9eeb9f.svg";